<p>task-unassgined works!</p>
<div class="mat-elevation-z4 orders-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-table">
  
      <ng-container matColumnDef="taskId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TASK ID</th>
        <td mat-cell *matCellDef="let order">{{ order.taskId }}</td>
      </ng-container>
  
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>USER</th>
        <td mat-cell *matCellDef="let order">
          <div class="user-cell-container">
            <span class="user-chip">{{ order.user || 'No User' }}</span>
            
            <!-- <ng-container *ngIf="order.status === 'Not Assigned'; else lockedStatus"> -->
              <ng-container >
              <button mat-icon-button 
                      [matMenuTriggerFor]="userMenu" 
                      (click)="getUserListtoAssign(order.taskId)">
                <mat-icon>expand_more</mat-icon>
              </button>
            </ng-container>
  
            <ng-template #lockedStatus>
              <mat-icon style="color: #ccc; font-size: 18px; margin-left: 8px;">lock</mat-icon>
            </ng-template>
          </div>
  
          <mat-menu #userMenu="matMenu" class="custom-vertical-menu">
            <div class="menu-inner-wrapper" (click)="$event.stopPropagation()">
              
              <div *ngIf="!editingCell[order.taskId]" class="selection-list animate-in">
                <div class="menu-title">SELECT USER</div>
                
                <div *ngIf="users.length === 0" style="padding: 16px; text-align: center; font-size: 12px; color: #888;">
                  Loading users...
                </div>
        
                <button mat-menu-item *ngFor="let user of users" 
                        (click)="selectedUserObj = user; startInstantEdit(order.taskId, user.name || user)">
                  <mat-icon color="primary">account_circle</mat-icon>
                  <span>{{ user.name || user }}</span> 
                </button>
              </div>
  
              <div *ngIf="editingCell[order.taskId]" class="confirmation-panel animate-in">
                <small>Assign to:</small>
                <div class="confirm-user-name">{{ selectedTempUser }}</div>
                <div class="confirm-button-row">
                  <button mat-mini-fab color="primary" 
                          (click)="saveCell(order, 'user', selectedUserObj?.user_id || selectedUserObj); userMenu.close.emit()">
                    <mat-icon>check</mat-icon>
                  </button>
                  <button mat-mini-fab color="warn" (click)="cancelInstantEdit(order.taskId)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
        
            </div>
          </mat-menu>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
        <td mat-cell *matCellDef="let order">
          <span [style.color]="order.status === 'Not Assigned' ? 'red' : 'inherit'">
            {{ order.status }}
          </span>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="Notified">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>RECEIVED AT</th>
        <td mat-cell *matCellDef="let order">{{ order.Notified }}</td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
    </table>
  
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
  </div>